/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, tree: NonNullable<unknown> }} Daily_Task_Tree_Type_Focus_TimesInputs */

const en_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("en", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Plant ${i?.tree} 1 time`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Plant ${i?.tree} ${i?.number} times`);
	return /** @type {LocalizedString} */ (`Plant ${i?.tree} ${i?.number} times`)
	
};

const ar_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ar", i?.number, {});
	if (numberPlural == "zero") return /** @type {LocalizedString} */ (`ازرع ${i?.tree} 0 مرة`);
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`ازرع ${i?.tree} مرة واحدة`);
	if (numberPlural == "two") return /** @type {LocalizedString} */ (`ازرع ${i?.tree} مرتين`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`ازرع ${i?.tree} ${i?.number} مرات`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`ازرع ${i?.tree} ${i?.number} مرة`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`ازرع ${i?.tree} ${i?.number} مرة`);
	return /** @type {LocalizedString} */ (`ازرع ${i?.tree} ${i?.number} مرة`)
	
};

const de_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("de", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Pflanze ${i?.tree} 1 Mal`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Pflanze ${i?.tree} ${i?.number} Mal`);
	return /** @type {LocalizedString} */ (`Pflanze ${i?.tree} ${i?.number} Mal`)
	
};

const es_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("es", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Planta ${i?.tree} 1 vez`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Planta ${i?.tree} ${i?.number} veces`);
	return /** @type {LocalizedString} */ (`Planta ${i?.tree} ${i?.number} veces`)
	
};

const fr_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("fr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Planter ${i?.tree} ${i?.number} fois`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Planter ${i?.tree} ${i?.number} fois`);
	return /** @type {LocalizedString} */ (`Planter ${i?.tree} ${i?.number} fois`)
	
};

const it_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("it", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Pianta ${i?.tree} 1 volta`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Pianta ${i?.tree} ${i?.number} volte`);
	return /** @type {LocalizedString} */ (`Pianta ${i?.tree} ${i?.number} volte`)
	
};

const ja_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ja", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.tree} を ${i?.number} 回植える`);
	return /** @type {LocalizedString} */ (`${i?.tree} を ${i?.number} 回植える`)
	
};

const ko_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ko", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.tree} ${i?.number} 회 심기`);
	return /** @type {LocalizedString} */ (`${i?.tree} ${i?.number} 회 심기`)
	
};

const pt_br_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("pt_br", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Plante ${i?.tree} ${i?.number} vez`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Plante ${i?.tree} ${i?.number} vezes`);
	return /** @type {LocalizedString} */ (`Plante ${i?.tree} ${i?.number} vezes`)
	
};

const ru_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ru", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Посади ${i?.tree} ${i?.number} раз`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`Посади ${i?.tree} ${i?.number} раза`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`Посади ${i?.tree} ${i?.number} раз`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Посади ${i?.tree} ${i?.number} раза`);
	return /** @type {LocalizedString} */ (`Посади ${i?.tree} ${i?.number} раза`)
	
};

const th_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("th", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`ปลูก${i?.tree} ${i?.number} ครั้ง`);
	return /** @type {LocalizedString} */ (`ปลูก${i?.tree} ${i?.number} ครั้ง`)
	
};

const tr_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("tr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`1 kez ${i?.tree} dik`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} kez ${i?.tree} dik`);
	return /** @type {LocalizedString} */ (`${i?.number} kez ${i?.tree} dik`)
	
};

const zh_cn_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_cn", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`种植 ${i?.tree} ${i?.number} 次`);
	return /** @type {LocalizedString} */ (`种植 ${i?.tree} ${i?.number} 次`)
	
};

const zh_tw_daily_task_tree_type_focus_times = /** @type {(inputs: Daily_Task_Tree_Type_Focus_TimesInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_tw", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`種植 ${i?.tree} ${i?.number} 次`);
	return /** @type {LocalizedString} */ (`種植 ${i?.tree} ${i?.number} 次`)
	
};

/**
* | numberPlural | output |
* | --- | --- |
* | "one" | "Plant {tree} 1 time" |
* | "other" | "Plant {tree} {number} times" |
* | * | "Plant {tree} {number} times" |
*
* @param {Daily_Task_Tree_Type_Focus_TimesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_task_tree_type_focus_times = /** @type {((inputs: Daily_Task_Tree_Type_Focus_TimesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Task_Tree_Type_Focus_TimesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_task_tree_type_focus_times(inputs)
	if (locale === "ar") return ar_daily_task_tree_type_focus_times(inputs)
	if (locale === "de") return de_daily_task_tree_type_focus_times(inputs)
	if (locale === "es") return es_daily_task_tree_type_focus_times(inputs)
	if (locale === "fr") return fr_daily_task_tree_type_focus_times(inputs)
	if (locale === "it") return it_daily_task_tree_type_focus_times(inputs)
	if (locale === "ja") return ja_daily_task_tree_type_focus_times(inputs)
	if (locale === "ko") return ko_daily_task_tree_type_focus_times(inputs)
	if (locale === "pt_br") return pt_br_daily_task_tree_type_focus_times(inputs)
	if (locale === "ru") return ru_daily_task_tree_type_focus_times(inputs)
	if (locale === "th") return th_daily_task_tree_type_focus_times(inputs)
	if (locale === "tr") return tr_daily_task_tree_type_focus_times(inputs)
	if (locale === "zh_cn") return zh_cn_daily_task_tree_type_focus_times(inputs)
	return zh_tw_daily_task_tree_type_focus_times(inputs)
});